export default __webpack_public_path__ + "dadf6cd85deed9f0f369c72594f39467.svg";